import { render, staticRenderFns } from "./noticeDetails.vue?vue&type=template&id=fdd74b20&scoped=true"
import script from "./noticeDetails.vue?vue&type=script&lang=js"
export * from "./noticeDetails.vue?vue&type=script&lang=js"
import style0 from "./noticeDetails.vue?vue&type=style&index=0&id=fdd74b20&prod&lang=scss&scoped=true"
import style1 from "./noticeDetails.vue?vue&type=style&index=1&id=fdd74b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd74b20",
  null
  
)

export default component.exports